<template>
    <div class="container">
        <div class="common-header-wrap">
            <mt-header :title="getTitle" class="common-header">
                <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
                <div class="common-btn btn" slot="right"  @click="onDelete" v-if="!isAddMode">删除</div>
            </mt-header>
        </div>
        <div class="main-content">
        <div v-if="isAddMode">
            <div @click="popupSelect = true">
            <flex-line :is-link="true" :show-border="true"><span class="line-name">{{getSelecedTitle}}</span></flex-line>
            </div>
            <mt-popup v-model="popupSelect" position="right" class="common-popup-wrapper" :modal="false">
                <div class="common-header-wrap">
                    <mt-header title="选择商品" class="common-header">
                        <mt-button slot="left" icon="back" @click.native="popupSelect = false"></mt-button>
                    </mt-header>
                </div>
                <div class="common-popup-content">
                <div v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
                <div class="select-goods" v-if="selectGoodsList">
                    <ul v-if="selectGoodsList.length">
                        <li v-for="item in selectGoodsList" v-bind:key="item.goods_commonid" @click="selectedGoods(item)">
                            <div class="p-img">
                                <img :src="item.goods_image"/>
                            </div>
                            <div class="p-info">
                                <p class="name">{{item.goods_name}}</p>
                                <p class="price">{{item.goods_price}}</p>
                            </div>
                        </li>
                    </ul>
                    <empty-record v-else></empty-record>
                </div>
                </div>
                </div>
            </mt-popup>
        </div>
        <div v-else>
            <flex-line :show-border="true"><span class="line-name">{{getSelecedTitle}}</span></flex-line>
        </div>
        <flex-line class="field-line" :show-border="true"><span class="field-name">佣金比例</span><div class="field-line-right" slot="right"><input class="field-input" v-model="goods.inviter_ratio" /></div></flex-line>
        <div class="pt-10 pb-10"><div class="common-btn ds-button-large" @click="submit">提交</div></div>
        </div>
    </div>
</template>

<script>
import { Toast, Indicator, MessageBox } from 'mint-ui'
import { searchGoodsList, addInviterGoods, editInviterGoods, getInviterGoodsInfo, delInviterGoods } from '../../../api/sellerInviter'
import EmptyRecord from '../../../components/EmptyRecord'
import flexLine from '../../flexLine'
export default {
  name: 'GoodsForm',
  data () {
    return {
      params: { 'page': 0, 'per_page': 10 },
        loading: false, // 是否加载更多
        isMore: true, // 是否有更多
      // 弹出选择商品
      popupSelect: false,
      // 商品列表用于选择商品设置分拥比例
      selectGoodsList: false,
      // 关键词
      selectGoodsName: '',
      goods: {
        'goods_commonid': 0,
        'goods_name': '',
        'inviter_ratio': '',
      }
    }
  },
  created: function () {
    if (!this.isAddMode) {
      this.goods.goods_commonid = this.$route.query.goods_commonid
      getInviterGoodsInfo(this.goods.goods_commonid).then(res => {
        this.goods = res.result.info
      }).catch(function (error) {
        Toast(error.message)
      })
    }
  },
  components:{
    flexLine,
    EmptyRecord
  },
  computed: {
    isAddMode () {
      let mode = this.$route.query.action
      if (mode === 'add') {
        return true
      } else {
        return false
      }
    },
    getTitle () {
      if (this.isAddMode) {
        return '新增分销商品'
      } else {
        return '修改分销商品'
      }
    },
    getSelecedTitle () {
      if (this.goods.goods_commonid) {
        return this.goods.goods_name
      } else {
        return '选择商品'
      }
    }
  },
  methods: {
    onDelete () {
      MessageBox.confirm('确定要取消该商品佣金设置吗？').then(action => {
        delInviterGoods(this.goods.goods_commonid).then(
          (response) => {
            this.$router.push({ name: 'SellerInviterGoodsList' })
          }, (error) => {
            Toast(error.message)
          })
      })
    },
    loadMore () {
          this.loading = true
          this.params.page = ++this.params.page
          if (this.isMore) {
              this.loading = false
              this.getSelectGoodsList(true)
          }
      },
      reload () {
          // 重新加载数据
          this.params.page = 0
          this.isMore = true
          this.selectGoodsList = []
          this.loadMore()
      },
    submit () {
      if (this.isAddMode) {
        Indicator.open()
        addInviterGoods(this.goods).then(
          (response) => {
            Indicator.close()
            Toast(response.message)
            this.$router.push({ name: 'SellerInviterGoodsList' })
          }, (error) => {
            Indicator.close()
            Toast(error.message)
          })
      } else {
        Indicator.open()
        editInviterGoods(this.goods).then(
          (response) => {
            Indicator.close()
            Toast(response.message)
            this.$router.push({ name: 'SellerInviterGoodsList' })
          }, (error) => {
            Indicator.close()
            Toast(error.message)
          })
      }
    },
    // 获取商品列表 用于设置产品分佣
    getSelectGoodsList () {
      searchGoodsList(this.selectGoodsName,this.params).then(res => {
        if (this.selectGoodsList) {
              this.selectGoodsList = this.selectGoodsList.concat(res.result.goods_list)
          } else {
              this.selectGoodsList = res.result.goods_list
          }
        if (res.result.hasmore) {
          this.isMore = true
        } else {
          this.isMore = false
        }
      }).catch(function (error) {
        Toast(error.message)
      })
    },
    // 选择商品
    selectedGoods (item) {
      this.goods.goods_name = item.goods_name
      this.goods.goods_commonid = item.goods_commonid
      // Close
      this.popupSelect = false
    }
  }
}
</script>

<style scoped  lang="scss">
.common-header{
        .btn{background: #000;color: #fff;box-shadow: 0px 2px 4px #d2d2d2;}
    }
.main-content{background: #fff;padding:0 $pageSpace}
.select-goods li{height:3rem;padding:.6rem;display:flex;}
.select-goods li .p-img{}
.select-goods li .p-img img{width:3rem;height: 3rem;}
.select-goods li .p-info{margin-left:1rem;}
.select-goods li .p-info p{line-height:1rem;}
.select-goods li .p-info .price{font-size:$fontSize;color:$primaryColor;height:2rem;overflow: hidden}
.select-goods li .p-info .name{font-size:$subFontSize;}

</style>
